export const replaceAndParseToNumber = (value = 0) => {
    return typeof value === 'number' ? value : Number(value?.replace(/,/g, '') ?? 0);
};

export const handleThousandSeparator = (value, flag = false) => {
    return flag ? value.toString().replace(/,/g, '') : value.toLocaleString("en");
};
